import React from "react";
import { observer } from "mobx-react";
import VariantRightSection from "./VariantRightSection";
import {
  ItemsStore,
  RolesAndPermissionStore,
} from "../../../../../shared/store";
import {
  ItemDetailLeftPanel,
  ItemDetailRightPanel,
  MainOuterCard,
  VariantWrapper,
} from "../../../../../shared/styles";
import {
  ActiveInactiveButton,
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  SapphireBlueButton,
} from "@mindmemobile/mm-shared-global";
import ItemMediaSection from "../../ItemMediaSection";
import {
  ProductItemModel,
  ProductVariantEditableModel,
} from "../../../../../shared/models";
import { VariantTable } from "./Variant.styles";

type IProps = {
  productName: string;
  itemStore?: ItemsStore;
  onCloseVariantEditPopup: (refresh: boolean) => void;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const VariantEditPopUp: React.FC<IProps> = ({
  itemStore,
  productName,
  onCloseVariantEditPopup,
  rolesAndPermissionStore,
}) => {
  if (!itemStore?.selectedProduct?.variants) return null;
  const featuredMedia =
    itemStore.selectedProduct.detailSection.medias.find(
      (m) => m.isFavourite === true
    ) || itemStore.selectedProduct.detailSection.medias[0];
  const component = (
    <VariantWrapper>
      <FlexContainer padding={"0px"}>
        <ItemDetailLeftPanel width={"45%"}>
          <MainOuterCard padding="20px">
            <FlexContainer spacing={15} padding="20px 0px">
              {featuredMedia && (
                <div className="edit-variant-image">
                  <ItemMediaSection medias={[featuredMedia]} />
                </div>
              )}
              <div>
                <FlexContainer spacing={20} fxLayout="column">
                  <CustomLabel fontSize="20px" fontWeight="600" margin="0px">
                    {productName}
                  </CustomLabel>
                  <ActiveInactiveButton minWidth="80px" fontWeight={"600"}>
                    Active
                  </ActiveInactiveButton>
                </FlexContainer>
              </div>
            </FlexContainer>
            <VariantTable
              selectedVariantIndex={
                itemStore?.selectedProduct?.selectedVariantIndex || 0
              }
              variants={itemStore?.selectedProduct?.variants}
              onClick={(newIndex) => {
                const newProduct = new ProductItemModel({
                  ...itemStore.selectedProduct,
                  selectedVariantIndex: newIndex,
                  selectedVariant:
                    itemStore.selectedProduct?.variants?.options[newIndex],
                });
                newProduct.editableVariant =
                  ProductVariantEditableModel.init(newProduct);
                itemStore.updateSelectedProduct(newProduct);
              }}
            />
          </MainOuterCard>
        </ItemDetailLeftPanel>

        <ItemDetailRightPanel
          className={"modal-right-panel"}
          width={"65%"}
          borderLeft={"none"}
          padding={"0px"}
        >
          <VariantRightSection
            rolesAndPermissionStore={rolesAndPermissionStore}
          />
        </ItemDetailRightPanel>
      </FlexContainer>
    </VariantWrapper>
  );

  const onSaveVariant = async () => {
    const doRefresh = await itemStore.onSaveVariant();
    onCloseVariantEditPopup(doRefresh);
  };

  const onClose = () => {
    itemStore.toggleEditVariants(false);
    onCloseVariantEditPopup(false);
  };

  return (
    <ModalComponent
      onClose={() => onClose()}
      title="Variant Details"
      titleFontSize="22px"
      bodyPadding="20px"
      showFooter={true}
      minHeight="350px"
      wrapperWidth="1200px"
      bodyBackgroundColor="#F4F7FB"
      footerHeight="auto"
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton disabled minWidth="120px" height="40px">
            Delete Variant
          </RedButton>
          <SapphireBlueButton
            minWidth="120px"
            height="40px"
            onClick={() => onClose()}
          >
            Close
          </SapphireBlueButton>
          <SapphireBlueButton
            primary
            minWidth="120px"
            height="40px"
            onClick={() => onSaveVariant()}
          >
            Save
          </SapphireBlueButton>
        </FlexContainer>
      }
    >
      {component}
    </ModalComponent>
  );
};

export default observer(VariantEditPopUp);
